<template>
  <div class="link-viewer" :style="containerStyle">
    <iframe
      v-if="data.link && data.link.length !== 0 && showLink"
      class="iframe-container"
      :src="iframeSource"
      scrolling="no"
      :style="{ zoom: iframeZoom }"
    />
    <div v-if="!data.link || data.link.length === 0" class="link-placeholder">
      <i class="material-icons-outlined align-middle">link</i>
      Website Link
    </div>
  </div>
</template>

<script>
  import { duration } from 'moment';
  import { getRBGAColor } from '@/helpers/utils';

  export default {
    name: 'LinkViewer',

    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      zoom: {
        type: Number,
        default: 1,
      },
    },

    data() {
      return {
        showLink: true,
        refreshTimer: null,
        refreshCount: 0,
      };
    },

    computed: {
      containerStyle() {
        return {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: getRBGAColor(this.data.backgroundColor, this.data.opacity / 100),
          zoom: this.zoom,
        };
      },

      iframeSource() {
        // Add refresh count as a query parameter to force iframe refresh
        const baseUrl = this.data.link || '';
        const hasQueryParams = baseUrl.includes('?');
        const separator = hasQueryParams ? '&' : '?';

        return `${baseUrl}${separator}_refresh=${this.refreshCount}`;
      },

      iframeZoom() {
        return (this.data.zoom || 100) / 100;
      },
    },

    mounted() {
      this.setupRefreshTimer();
    },

    beforeDestroy() {
      this.clearRefreshTimer();
    },

    watch: {
      data: {
        handler() {
          this.setupRefreshTimer();
        },
        deep: true,
      },
    },

    methods: {
      setupRefreshTimer() {
        this.clearRefreshTimer();

        if (
          this.data.refresh &&
          this.data.refreshTime &&
          this.data.refreshTime > 0 &&
          this.data.link
        ) {
          const refreshInterval = duration(
            this.data.refreshTime || 24,
            this.data.timeUnit || 'hours',
          ).asMilliseconds();

          this.refreshTimer = setInterval(this.refreshLink, refreshInterval);
        }
      },

      clearRefreshTimer() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer);
          this.refreshTimer = null;
        }
      },

      refreshLink() {
        this.showLink = false;
        this.refreshCount++;

        setTimeout(() => {
          this.showLink = true;
        }, 100);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .link-viewer {
    position: relative;
    overflow: hidden;
  }

  .iframe-container {
    width: 100%;
    height: 100%;
    border: 0;
    pointer-events: none;
    overflow: hidden;
  }

  .link-placeholder {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: #757575;
    font-size: 32px;

    i {
      font-size: 64px;
    }
  }
</style>
